<template>
  <div class="overflow-hidden">
    <v-app-bar
      color="#1975d2"
      class="px-sm text-left shadow-sm"
      flat
      height="100"
      absolute
      prominent
    >
      <v-container class="d-flex align-center mt-2">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="black"
        />
        <v-toolbar-title
          v-if="!isDashboard"
          class="white--text"
        >
          <v-avatar
            tile
          >
            <v-img
              contain
              class="primary"
              :src="channel.logo || defaultIcon"
              height="30"
            />
          </v-avatar>
          <a
            :href="`/channel/` + channel.id + `/on-air`"
            class="white--text p-l-20"
          >
            {{ channel.name }}
            <v-tooltip
              v-if="channel.suspended"
              color="#111"
              top
            >
              <template v-slot:activator="{ on }">
                <i
                  class="mdi mdi-pause-circle-outline red--text m-l-10"
                  v-on="on"
                />
              </template>
              <div class="tooltip-body">
                Temporarily stopped
              </div>
            </v-tooltip>
          </a>
          <span
            v-if="currentTz"
            class="p-l-30"
            style="color: #ccc"
          >
            {{ currentTz }} {{ tz }}
          </span>
        </v-toolbar-title>
        <v-toolbar-title
          v-else
          class="white--text p-t-10"
        >
          <a href="/">
            <v-img
              alt="Noisypeak Playout"
              class="shrink"
              contain
              src="/images/Noisypeak_Playout_Logo_20_beta_w.png"
              transition="scale-transition"
              max-width="300"
            />
          </a>
        </v-toolbar-title>
        <v-spacer />
        <v-menu
          offset-y
          right
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn
              color="white"
              v-bind="attrs"
              text
              v-on="on"
            >
              {{ username }}<v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="goToProfile">
              <v-list-item-title>
                <v-icon class="mr-1">
                  mdi-account
                </v-icon>Profile
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title>
                <v-icon class="mr-1">
                  mdi-logout
                </v-icon>Sign Out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
  import { processChannel } from '@/store/converters'
  import moment from 'moment-timezone'

  export default {
    name: 'AppBar',
    data () {
      return {
        isDashboard: true,
        polling: null,
        tz: '',
        currentTz: null,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      username () {
        return this.$store.getters.getUsername ? this.$store.getters.getUsername : ''
      },
      channel () {
        if (this.$store.getters.channel) {
          return processChannel(this.$store.getters.channel)
        }
        return {}
      },
      defaultIcon () {
        return '/images/default_channel_logo.png'
      },
    },
    watch: {
      '$route' (to, from) {
        this.isDashboard = !to.params.id
      },
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    mounted () {
      this.updateTime()
    },
    created () {
      this.isDashboard = !this.$route.params.id
    },
    methods: {
      goToProfile () {
        this.$router.push({ name: 'ProfileInfoPage' })
      },
      logout () {
        this.$store.dispatch('logout')
        this.$router.push({ name: 'SignIn' })
      },
      updateTime () {
        this.polling = setInterval(() => {
          if (this.channel && this.channel.timezone) {
            this.tz = moment.tz(this.channel.timezone.name).format('z')
            this.currentTz = moment.utc(moment().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('HH:mm:ss')
          }
        }, 1000)
      },
    },
  }
</script>
